import React from 'react'
import img1 from '../../imgs/saude-bucal/siso/img-1.png'
import img2 from '../../imgs/saude-bucal/siso/img-2.png'
import img3 from '../../imgs/saude-bucal/siso/img-3.png'
import Carroussel from '../../components/Carroussel'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export default function Siso() {
	const cardsData = [
		{
			id: 1,
			image: img1,
		},
		{
			id: 2,
			image: img2,
		},
		{
			id: 3,
			image: img3,
		},
	]
	return (
		<div className='container' style={{ paddingTop: 60, paddingBottom: 120, background: 'linear-gradient(to bottom, #d1f0ff, #e2fff5)' }}>
			<h1 className='title'>DENTE DO SISO</h1>
			<p><ArrowForwardIcon fontSize='small' />Os dentes do siso, também conhecidos como terceiros molares, são os últimos dentes a se desenvolverem em boca;</p>
			<p><ArrowForwardIcon fontSize='small' />Normalmente, eles aparecem entre os 17 e 25 anos, variando de pessoa para pessoa;</p>
			<p style={{ fontSize: '18px' }}className='atencao'>Por quê eles podem causar problemas?</p>

			<p><ArrowForwardIcon fontSize='small' /><b>Difícil de limpar:</b> Mesmo que cresçam corretamente, eles estão no fundo da boca e isso acaba dificultando a correta higienização.  Isso pode levar a cáries e infecções.</p>
			<h4 style={{ textAlign: 'center', marginBottom: 0 }}>Sintomas de problemas com o dente do siso</h4><br />

			<p style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}><ArrowForwardIcon fontSize='small' />Gengivas inchadas ou sensíveis.</p>
			<p style={{ display: 'flex', alignContent: 'center', alignItems: 'center' }}><ArrowForwardIcon fontSize='small' />Mau hálito ou gosto ruim na boca.</p>

			<p style={{ display: 'flex', alignContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>A boa notícia é que a remoção do dente do siso está entre os procedimentos cirúrgicos que podem ser realizados no SUS. Procure uma Unidade Básica de Saúde (UBS ou UBSF) mais próxima do seu bairro…</p>


			<Carroussel cardsData={cardsData} />

		</div >
	)
};